import * as Sentry from '@sentry/react';

export type ItemEntry = 'scan' | 'itemNumber' | 'search' | 'notification';

type Attributes = Record<string, string | number | boolean>;

let currentEntry: ItemEntry | null = null;

export function setItemEntry(entry: ItemEntry) {
  currentEntry = entry;
  Sentry.setTag('slm.itemEntry', entry);
}

export function startSpanTelemetry(name: string, attributes: Attributes = {}) {
  let span: ReturnType<typeof Sentry.startInactiveSpan>;
  try {
    span = Sentry.startInactiveSpan({
      name,
      op: name,
      forceTransaction: true,
      attributes: currentEntry
        ? { ...attributes, 'slm.itemEntry': currentEntry }
        : attributes,
    });
  } catch {
    /* ignore */
  }
  return (extra: Attributes = {}) => {
    try {
      Object.entries(extra).forEach(([key, value]) =>
        span?.setAttribute(key, value)
      );
      span?.end();
    } catch {
      /* ignore */
    }
  };
}
